<div class="switcher-container">
    <div class="emd-container__header emd-text emd _size_section _weight_extra-bold _color_subtle">
        {{ label() }}
    </div>
    <hr class="emd-divider" />

    <div class="emd-container__content d-flex flex-wrap align-items-center" style="gap: 2rem">
        <label class="emd-switcher__label" [for]="'enable-disable-' + controlName" style="min-width: 40px; margin-bottom: 8">
            Habilitar?
        </label>
        <label class="switch" [for]="'enable-disable-' + controlName">
            <input
                (blur)="onTouched()"
                type="checkbox"
                [checked]="control().value"
                [id]="'enable-disable-' + controlName"
                (change)="onChange(value)"
                [(ngModel)]="value"
            />
            <span class="slider round"></span>
        </label>
    </div>
</div>
